<evc-modal
  [showReduceButton]="false"
  [options]="options()"
  [styles]="{ width: '600px', maxWidth: '100%' }">
  <span modal-title>{{ ('menus.help.about' | platformTranslate)() }}</span>

  <div
    modal-content
    class="about">
    @let identity = appIdentity()!;
    @let logo = identity.logo;
    @let title = identity.title | optionalAsync;
    @let version = identity.version | optionalAsync;
    @let copyright = (identity.copyright | optionalAsync) ?? '';

    <evc-icon
      svgPath="{{ basePath() }}apps/evident-logo.svg#evident"
      class="about__logo" />
    <div class="about__text">
      @if (title || logo) {
        <p class="about__app">
          @if (logo) {
            <evc-icon
              [svgPath]="logo"
              size="md"
              class="about__icon" />
          }
          @if (title) {
            <span>{{ title }}</span>
          }
        </p>
      }
      @if (version) {
        <p>{{ version }}</p>
      }
      @if (copyright) {
        <evc-copyright [copyRightText]="copyright"></evc-copyright>
      }
    </div>
  </div>
</evc-modal>
